import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import AddToCalendar from '../AddToCalendar';
import ArrowRight from '../icons/ArrowRight';
import css from './index.module.scss';
import SelectStyled from '../SelectStyled';

const EventMap = dynamic(() => import('../EventMap'), { ssr: false });

const Details = ({
  button,
  date,
  dates,
  discloseSharedMarketing,
  disclosure,
  displayLocation,
  mapsURL,
  onDateChange,
  rsvped,
}) => {
  const { description, isAllDay, locations } = date;
  const startLocation = locations[0];
  const endLocation = locations[1];
  const timeLabel = isAllDay ? '' : ' and Time';
  return (
    <div className={css.root}>
      <div className={css.map}>
        {displayLocation && <EventMap markers={locations} key={locations.map((location) => location.id).join('-')} />}
      </div>
      <div className={css.form}>
        <div className={css.fields}>
          <div className={css.fieldRow}>
            <div className={css.field}>
              {dates.length > 1 ? (
                <>
                  <span className={css.timeLocationLabel}>Select Date{timeLabel}:</span>
                  <SelectStyled
                    label="Select Date:"
                    hideLabel
                    name="date-select"
                    onChange={onDateChange}
                    options={dates}
                    value={date.value}
                  />
                </>
              ) : (
                <>
                  <span className={css.timeLocationLabel}>Date{timeLabel}:</span>
                  <h2 className={css.timeLocationDetail}>{date.label}</h2>
                </>
              )}
            </div>
          </div>
          {displayLocation && (
            <div className={css.fieldRow}>
              <div className={css.field}>
                <div className={css.timeLocation}>
                  <div className={css.timeLocationCol}>
                    <span className={css.timeLocationLabel}>Location:</span>
                    <h2 className={css.timeLocationDetail}>
                      <div>
                        {startLocation.name}
                        <div className={css.timeLocationAddress}>
                          {startLocation.address1}, {startLocation.city} {startLocation.state}
                        </div>
                      </div>
                      {endLocation && (
                        <>
                          <ArrowRight className={css.timeLocationArrow} />
                          <div>
                            {endLocation.name}
                            <div className={css.timeLocationAddress}>
                              {endLocation.address1}, {endLocation.city} {endLocation.state}
                            </div>
                          </div>
                        </>
                      )}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          )}
          {description && (
            <div className={css.field}>
              <div className={css.description} dangerouslySetInnerHTML={{ __html: description }} />
            </div>
          )}
          <div className={css.button}>
            {button}
            {rsvped && (
              <AddToCalendar buttonProps={{ big: true, bordered: true }} id={date.id} gcalUrl={date.gcalUrl}>
                Add To Calendar
              </AddToCalendar>
            )}
          </div>
          {discloseSharedMarketing && <div className={css.disclosure}>{disclosure}</div>}
        </div>
      </div>
      {displayLocation && (
        <p className={css.mapLink}>
          <a href={mapsURL} target="_blank" rel="noopener noreferrer">
            View in Google Maps
          </a>
        </p>
      )}
    </div>
  );
};
Details.defaultProps = {
  discloseSharedMarketing: false,
  disclosure: '',
};
Details.propTypes = {
  button: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.node]).isRequired,
  date: PropTypes.shape({
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    id: PropTypes.string,
    isAllDay: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    gcalUrl: PropTypes.string,
    locations: PropTypes.arrayOf(
      PropTypes.shape({
        address1: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        city: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        lng: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        name: PropTypes.string.isRequired,
        state: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      }),
    ).isRequired,
    time: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  }).isRequired,
  dates: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    }),
  ).isRequired,
  discloseSharedMarketing: PropTypes.bool,
  disclosure: PropTypes.string,
  displayLocation: PropTypes.bool.isRequired,
  mapsURL: PropTypes.string.isRequired,
  onDateChange: PropTypes.func.isRequired,
  rsvped: PropTypes.bool.isRequired,
};

export default Details;
